import { AlertDiamondLight, CheckCircle1Light } from '@ha/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, Theme } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { Grid, Typography, units } from '@ha/dsl';
import Dialog from 'ha/components/next/Dialog';
import { getIsAdvertiser } from 'ha/modules/AuthLogic/selectors';

import { getIsErrorSearchAlert } from '../../selectors/searchAlertSelectors';

const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    textAlign: 'center',
    height: '100%',

    [theme.breakpoints.up('sm')]: {
      marginBottom: units.rem(2.5),
      marginTop: units.rem(0.5),
    },
  },
  content: {
    marginTop: units.rem(1),
    marginBottom: units.rem(2.5),
  },
  iconWrapper: {
    marginTop: units.rem(2),
  },
  icon: {
    width: units.rem(3.2),
    height: units.rem(3.2),
  },
  paragraphWrapper: {
    marginTop: units.rem(0.5),
  },
  dialogPaper: {
    maxWidth: '500px',
  },
}));

interface Props {
  isOpen: boolean;
  onClose: () => void;
  hasAlert: boolean;
}

const SearchAlertResponseDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  hasAlert,
}) => {
  const classes = useStyles();
  const { T } = useIntl();
  const { sm } = useMediaQuery();

  const isAdvertiser = useSelector(getIsAdvertiser);
  const hasError = useSelector(getIsErrorSearchAlert);

  return (
    <Dialog
      show={isOpen}
      maxWidth="xs"
      fullScreen={!sm}
      onClose={onClose}
      dataTestLocator="Search Alert Response"
      classes={{
        paper: classes.dialogPaper,
      }}
      content={
        <Grid
          className={classes.gridContainer}
          container
          direction="column"
          justify="center"
        >
          <Grid item className={classes.iconWrapper}>
            {hasError ? (
              <AlertDiamondLight color="error" className={classes.icon} />
            ) : (
              <CheckCircle1Light color="secondary" className={classes.icon} />
            )}
          </Grid>

          <Grid item className={classes.content}>
            <Typography.H3 align="center">
              {hasError
                ? hasAlert
                  ? T('search_alert_update_error_message')
                  : T('search_alert_create_error_message')
                : hasAlert
                ? T('search_alert_updated_successfully')
                : T('search_alert_created_successfully')}
            </Typography.H3>

            <div className={classes.paragraphWrapper}>
              {!isAdvertiser && (
                <Typography.Paragraph align="center">
                  {T('search_alert_manage_in_menu')}
                </Typography.Paragraph>
              )}

              {hasError && (
                <Typography.Paragraph
                  align="center"
                  data-test-locator="Search Alert Upsert Error"
                >
                  {T('search_alert_error_try_again')}
                </Typography.Paragraph>
              )}
            </div>
          </Grid>
        </Grid>
      }
    />
  );
};

export default SearchAlertResponseDialog;
